import { Component, OnInit } from '@angular/core';
import { CardItemComponent } from '../card-item.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-card-item-boolean',
  templateUrl: './card-item-boolean.component.html',
  styleUrls: [
    './card-item-boolean.component.scss',
    '../card-item.component.scss',
  ],
  standalone: false,
})
export class CardItemBooleanComponent extends CardItemComponent {
  constructor() {
    super();
  }
}
